module.exports = "/_next/static/images/down-line-8cf0ca9680f5f13302b612df9feb73d2.svg";